var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFewCloudsNightIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.358,
    height: 24,
    viewBox: "0 0 24.358 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "few-clouds-night-icon",
    transform: "translate(-121 -69)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_90",
    "data-name": "Group 90",
    transform: "translate(121 127)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Area",
    width: 16,
    height: 16,
    transform: "translate(7.5 -57.5)",
    fill: "rgba(252,252,252,0)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Path",
    cx: 5.775,
    cy: 5.775,
    r: 5.775,
    transform: "translate(10 -55.275)",
    fill: "none",
    stroke: "#012739",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_91",
    "data-name": "Group 91",
    transform: "translate(121 127)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Area-2",
    "data-name": "Area",
    width: 24,
    height: 24,
    transform: "translate(0 -58)",
    fill: "rgba(252,252,252,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M19.132-45H17.04c-1.463-5.664-8.64-8.338-13.768-3.441a5.626,5.626,0,0,0-1.415,2.174C-.305-40.174,4.014-35,9.3-35h9c3.919,0,6.785-4.507,3.7-8.62A3.571,3.571,0,0,0,19.132-45Z",
    fill: "#fff",
    stroke: "#364456",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFewCloudsNightIcon);
export default __webpack_public_path__ + "static/media/few-clouds-night-icon.a8af86ad662af34764355df0999be61f.svg";
export { ForwardRef as ReactComponent };